import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;

  gap: 1rem;
`;

export default Wrapper;
